<template>
  <div class="sender-header">
    <div
        v-if="fileList.length > 0"
        class="file-list-container"
    >
      <el-x-attachments
          :hide-upload="true"
          :items="mappedFileList"
          @delete-card="handleDeleteFile"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SenderHeader',
  props: {
    fileList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    mappedFileList() {
      return this.fileList.map(file => ({
        ...file,
        fileType: this.mapFileType(file.type),
        // 上传进度相关属性，用于显示上传进度
        status: file.status || 'done', // 'uploading' | 'done' | 'error'
        percent: typeof file.percent === 'number' ? file.percent : 100, // 0-100
        errorTip: file.errorTip || undefined,
        // 确保删除按钮显示
        showDelIcon: true,
      }));
    },
  },
  methods: {
    // 将 MIME 类型映射到 el-x-files-card 组件类型
    mapFileType(mimeType) {
      if (!mimeType) return 'unknown';

      const type = mimeType.toLowerCase();

      if (type.startsWith('image/')) {
        return 'image';
      }

      if (type.startsWith('audio/')) {
        return 'audio';
      }

      if (type.startsWith('video/')) {
        return 'video';
      }

      const documentMimes = [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'text/plain',
        'text/csv',
        'application/json',
        'text/html',
        'text/css',
        'application/javascript',
      ];

      if (documentMimes.includes(type)) {
        return 'file';
      }

      const otherMimes = [
        'application/zip',
        'application/x-rar-compressed',
        'application/octet-stream',
      ];

      if (otherMimes.includes(type)) {
        return 'file';
      }

      return 'unknown';
    },

    // 处理文件删除
    handleDeleteFile(item, index) {
      this.$emit('delete-file', item, index);
    },
  },
};
</script>

<style lang="scss" scoped>
.sender-header {
  .file-list-container {
    padding: 8px 0;
    border-bottom: 1px solid #ebeef5;
  }
}
</style>
